module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Thin.0d61db61.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sf-ui-text/SFProDisplay-Thin.otf
// module id = 751
// module chunks = 0